import React, { Component} from 'react';
import ServiceApi from "../requests"
import config from "./../../../config/config";
import Cookies from 'universal-cookie';

import { Link  } from 'react-router-dom';

//import LoginTemplate from './Index.jxs'
import logo from '../../assets/images/movistar.svg';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
/* COMPONENTS STYLES */
//import styles from './Index.scss';
//Importar clase de unificacion de peticiones
// import UnifiqueRequest from '../UnifiqueRequest/httpRequest';

const cookies = new Cookies();

class Login extends Component{
    constructor(props){
        super(props);
        this.state={
            user:'',
            password:'',
            isAuthenticate: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentWillMount(){


    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const form = event.target.elements
        const data = {
            user: this.state.user,
            password: this.state.password,

        }

        console.log("estamos aqui ")
        ServiceApi(data, `${config.url}/login`, 'POST')
            .then(response => {
                console.log("respose", response)
                if (response.success){
                    cookies.set('login', response, {expires: new Date(Date.now()+ 600000)});
                   let prueba =  cookies.get('login').token
                    window.location.assign(config.urlFront + '/')

                }
                else{
console.log("error")
                }
            }).catch(error => {
            this.setState({
                showError:true,
                loading:false
            });
        });



    }

    render(){

        return(
            <div className="Login">
                <form className="form-signin" onSubmit={this.handleSubmit} id="login">
                    <ToastContainer />
                    <div className="text-center mb-4">
                        <div className="mb-30">
                            <svg width="43px" height="30px" viewBox="0 0 53 40" version="1.1">
                                <desc>Created with Sketch.</desc>
                                <defs></defs>
                                <g id="Navbar" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Navbar/Menu-D/logged" transform="translate(-80.000000, -60.000000)" fill="#5BC500">
                                        <g id="Group-2" transform="translate(0.000000, 40.000000)">
                                            <g id="D-Header-main">
                                                <g id="Movistar-Lockup-Logo">
                                                    <g id="Logo" transform="translate(80.000000, 20.000000)">
                                                        <g id="Nuestra-M" transform="translate(0.000000, 0.371369)">
                                                            <path d="M9.83525544,4.82267499 C7.41093049,4.86091583 2.93675221,6.05648323 0.89267108,14.4030877 C0.00230888091,18.0402967 -0.341858679,21.8311905 0.42007202,26.3436096 C1.12283765,30.5053674 2.36819028,34.0978418 3.20732419,36.0769857 C3.49665583,36.7595486 3.94472303,37.4709725 4.29105516,37.9082169 C5.28676006,39.1672785 6.94482516,39.0871892 7.64109705,38.7437431 C8.40086318,38.369993 9.27390877,37.4673649 8.9578807,35.4066887 C8.80491734,34.4109838 8.36478691,32.9542243 8.11730374,32.1446729 C7.35609457,29.6597398 6.3437946,26.6618023 6.25576851,24.526809 C6.13743836,21.6695688 7.26373933,21.2965403 8.01196105,21.131311 C9.26957962,20.8549668 10.3244496,22.2359662 11.3259267,23.9669053 C12.5214941,26.0326322 14.5706259,29.6936515 16.2416784,32.4888405 C17.7511093,35.0134574 20.5354754,37.7155696 25.0074891,37.5301376 C29.5668074,37.341098 32.9269506,35.6015005 34.6578898,30.1258452 C35.9530276,26.0283031 36.8361746,22.9668713 38.2575794,19.8318439 C39.8911126,16.2263821 42.0708405,14.2970235 43.9056793,14.8857881 C45.609922,15.4334258 46.0349004,17.0987062 46.0558247,19.5468414 C46.0738628,21.7128603 45.8234935,24.1003875 45.6286817,25.8544155 C45.5579722,26.4908008 45.4295407,27.7707866 45.4822121,28.4822106 C45.5846686,29.879805 46.1900284,31.2752349 47.763675,31.4989078 C49.4404998,31.7362896 50.7854229,30.3971387 51.3222377,28.7780359 C51.5336446,28.1387645 51.7147475,27.1625408 51.8121534,26.469155 C52.3049551,22.9697574 52.4333866,20.617585 52.2104353,17.036655 C51.9506862,12.8496438 51.131755,9.03133197 49.7016919,5.7274677 C48.3344015,2.56718696 46.137357,0.541865488 43.3205223,0.362927217 C40.20209,0.16522929 36.6233246,2.2345638 34.7459158,6.24840895 C33.0156982,9.94839061 31.6310912,13.7472212 30.7912358,15.6859597 C29.9398359,17.6521161 28.6879896,18.863557 26.7636816,19.0663056 C24.4107877,19.3137888 22.3833016,17.6059384 20.8984026,15.1700691 C19.6032647,13.0466202 17.0375208,9.00463553 15.6651797,7.64672495 C14.3750925,6.37106825 12.9017379,4.7743328 9.83525544,4.82267499" id="Fill-4"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <h1 className="h3 mb-3 font-weight-normal fc-gray"> Recargas Movistar pruebas</h1>
                        <p className="fc-silver">Ingesa tu email y contraseña para acceder al panel de administración</p>
                    </div>

                    <div className="form-label-group">
                        <input type="text" id="email"  name="user" className="form-control primary"  required autoFocus value={this.state.user} onChange={this.handleInputChange}/>
                        <label htmlFor="email">Usuario o Correo electrónico</label>
                    </div>

                    <div className="form-label-group">
                        <input type="password" id="password" name="password" className="form-control primary"  required value={this.state.password} onChange={this.handleInputChange}/>
                        <label htmlFor="password">Contraseña</label>
                    </div>
                    <button className="btn-t col-12 " type="submit">Sign in</button>
                </form>
            </div>
        )
    }

}

export default Login